import { currentISODate } from "@/utility";
import BaseInputControl from "./BaseInputControl";
import type { HandleInputChange } from "./types";

type DateInputProps = {
    name: string;
    value?: string | number;
    placeholder?: string;
    future?: boolean;
    onChange: HandleInputChange;
};

const DateInput = ({ name, value, placeholder, future = false, onChange }: DateInputProps) => {
    return (
        <BaseInputControl
            type="date"
            name={name}
            value={value}
            placeholder={placeholder}
            onChange={onChange}
            min={future ? currentISODate() : undefined}
            max={!future ? currentISODate() : undefined}
        />
    );
};

export default DateInput;
